module.exports = "https://health.dajiuxing.com.cn/img/assets/login/Securityicon.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Flogin%2FSecurityicon.png
// module id = B2NQ
// module chunks = 93